import React, { useEffect } from 'react';

/**
 * Custom hook to dynamically load and manage the Jira Service Management widget.
 * 
 * @param {boolean} testStarted - Indicates whether the test has started.
 * @param {boolean} testInstructionsOpen - Indicates whether test instructions are open.
 */
const useContactUsIcon = (
    testStarted: boolean,
    testInstructionsOpen: boolean,
    jiraKey: string | undefined
) => {
    useEffect(() => {
        let script: HTMLScriptElement | null = null;
        // Dynamically load the widget script when conditions are met
        if (!testStarted && !testInstructionsOpen && jiraKey) {
            const existingScript = document.getElementById('jiraWidget');
            if (existingScript) {
                // document.body.removeChild(existingScript);
                return;
            }
            // Create the script element
            script = document.createElement('script');
            script.src = 'https://jsd-widget.atlassian.com/assets/embed.js'; // Replace with the actual widget script source
            script.id = 'jiraWidget';
            script.setAttribute('async', 'true');
            script.setAttribute('data-jsd-embedded', '');
            script.setAttribute('data-key', jiraKey); // Replace with your data key
            script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com'); // Replace with your base URL

            // Append the script to the document body
            document.body.appendChild(script);

            // Ensure the widget loads by triggering a DOMContentLoaded event
            script.addEventListener('load', () => {
                document.dispatchEvent(
                    new Event('DOMContentLoaded', {
                        bubbles: true,
                        cancelable: true,
                    })
                );
            });

            // Do not remove the code block below; it is kept for reference
            
            // Cleanup function to remove script and related DOM elements
            // return () => {
            //     if (script) {
            //         document.body.removeChild(script);
            //     }

            //     // Remove dynamically added elements by the widget
            //     const dynamicElements = ['jsd-widget'];
            //     dynamicElements.forEach((selector) => {
            //         const element = document.getElementById(selector);
            //         if (element) {
            //             element.parentElement?.removeChild(element);
            //         }
            //     });
            //     console.log('unload jira widget');
            //     // Cleanup body attributes added by the widget
            //     document.body.removeAttribute('data-embeddable');
            //     document.body.removeAttribute('data-new-gr-c-s-check-loaded');
            //     document.body.removeAttribute('data-gr-ext-installed');
            // };
        } else {
            // Remove the script if conditions are not met
            const existingScript = document.getElementById('jiraWidget');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        }
    }, [testStarted, testInstructionsOpen, jiraKey]); // Rerun effect when dependencies change
};

export default useContactUsIcon;